import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import './darkSearchInput.scss';
import { SearchIcon } from '~svg';
const DarkSearchInput = (props) => {
  const {
    name,
    value,
    className,
    type,
    label,
    onChange,
    icon,
    intl,
    isMobile,
    language: { direction },
    boxColor,
    inputClassName,
  } = props;
  return (
    <div
      className={` ${className}  ${
        isMobile
          ? 'mobile-dark-search-input-container'
          : 'dark-search-input-container'
      }
      justify-content-center align-items-center h-100 d-flex `}
    >
      <div
        className={`${boxColor} border col-11 h-100 px-sm-3 px-2 h-100 darkSearchinput`}
      >
        {icon ? (
          <div className="col-sm-1 col-2 px-0 d-flex flex-row justify-content-start">
            <SearchIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
          </div>
        ) : (
          <React.Fragment></React.Fragment>
        )}
        {/* default props from inputClassName is px-3 */}
        <input
          className={`col px-0 font-xl-small font-md-smaller font-xsmall text-truncate ${inputClassName}`}
          name={name}
          placeholder={intl.formatMessage({ id: label })}
          value={value}
          type={type}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
DarkSearchInput.propTypes = {
  intl: PropTypes.object,
  language: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.string,
  icon: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  boxColor: PropTypes.string,
  isMobile: PropTypes.bool,
  inputClassName: PropTypes.string,
};
DarkSearchInput.defaultProps = {
  intl: {},
  language: PropTypes.object,
  onChange: () => null,
  label: 'profile.search',
  icon: true,
  className: 'search-box position-relative',
  name: '',
  value: '',
  type: 'text',
  boxColor: 'bg-white',
  isMobile: false,
  inputClassName: 'px-3',
};
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}
export default connect(mapStateToProps)(injectIntl(DarkSearchInput));
